import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';
import axiosInstance from '../api/axios';
import bgrnd from '../assets/backs.png'
import DOMPurify from 'dompurify';

function Position() {

  const [positions, setPositions] = useState([]);

  useEffect(() => {
    axiosInstance.get('positions/')
      .then((response) => {
        setPositions(response.data);
      })
      .catch((error) => {
        console.error('Error fetching positions:', error);
      });
  }, []);

  return (
    <div>
      <div className="relative h-[300px] sm:h-[300px] overflow-hidden">
        <img
            src={bgrnd}
            alt= "background"
            className="absolute inset-0 w-full h-full object-cover z-0"
        />
        <div className="relative z-10 bg-black bg-opacity-30 flex flex-col items-center justify-center h-full text-white px-4">
        {/* Heading */} 
        <h1 className="font-semibold text-center leading-tight text-[50px] sm:text-[50px] md:text-[60px] lg:text-[70px] xl:text-[70px]">Open Positions 🔬</h1>
        </div>
      </div>
      <div className="px-6 py-12 max-w-5xl mx-auto text-gray-900">
        {/* Expandable Box */}
        <motion.div
          whileHover={{ scale: 1.2 }}
          transition={{ type: 'spring', stiffness: 150, damping: 15 }}
          className="bg-gray-100 rounded-xl shadow-md p-8 space-y-10 transition-all duration-300"
        >
          
          {positions.length === 0 ? (
            <p className="text-center text-gray-600">No open positions at the moment.</p>
          ) : (
            positions.map((pos, index) => {
              const sanitizedposition = DOMPurify.sanitize(pos.description);
              return(
                <div key={index} className="grid md:grid-cols-5 gap-6 mb-6 items-start">
                  <h2 className="font-semibold text-lg col-span-1">{pos.position}:</h2>
                  <div className="text-gray-700 col-span-4 text-justify" dangerouslySetInnerHTML={{ __html: sanitizedposition}} />
                </div>
            )})
          )} 
        </motion.div>
        <h3 className="text-xl text-center my-12 text-black">
          Please email your Curriculum vitae and Letter of Recommendation along with your Research Interests to:
            <span className='text-purple-900'>
              <a href={`mailto:rajendra.bce@iitbhu.ac.in`}> rajendra.bce@iitbhu.ac.in</a>
            </span>
        </h3>
      </div>
    </div>
  );
}

export default Position;
